const data = [
  {
    question: "Will the mushroom grow out of the growing bag by itself ?",
    answer:
      " Although it might take up to a month, the Reishi mushroom will in 99% of cases grow out of the bag by itself.So there is really no need to open up the bag! In fact, opening up the bag would harm the Reishi mushroom as it would allow competing fungal species to enter the substrate bag.",
  },
  {
    question:
      " Can I reuse the plastic dome and the plastic saucer of the ReishiGrowkit ?",

    answer:
      " Yes, you definitely can, and I encourage you to do so! All you need to do is order a new Reishi growbag and place it in the Reishi Growkit as soon as theReishi fruiting body is coming out at the top of the Reishi growbag.",
  },
  {
    question: "What is in the filter bag ?",
    answer:
      "Inside the filter bag, mushroom substrate can be found which contain oak sawdust, natural gypsum, wheat grains and water. The white material is mycelium from the Reishi mushroom, which is “colonizing” or “engulfing” the oak sawdust.",
  },
  {
    question:
      "The substrate filter bag looks like it has shrunk, is this normal ?",
    answer:
      "During colonization of the oak sawdust, the Reishi mycelium starts to eat the cellulose and ligno-cellulose that sits inside the oak sawdust. During this process, the substrate bag will shrink, which is completely normal",
  },
  {
    question:
      " I see brown liquid or brown coloration on top of the mushroomsubstrate, is this normal ?",
    answer:
      " The Reishi mycelium is known to produce all sorts of colors, from white, yellow, orange, red to brown. All of these colorationsrepresent different phases of the Reishi mycelium growth and can be considered completely normal.",
  },
  {
    question:
      " Can I grow other species of mushroom using the Reishi Growkit’splastic dome ?",
    answer:
      " As the Reishi Growkit’s microclimate is designed to exactly matchthe needs of a growing Reishi mushroom,other species of mushroom will not likely grow well under the plastic dome. Therefore my advice would be to not even try this.",
  },
  {
    question:
      "There is green coloration on the substrate or on the mushroom itself, especially at the tips of the mushroom. What does this mean ?",
    answer:
      "This is very likely either Trichoderma (parasitic fungus) or a green Aspergillus species. Green coloration indicates that the Reishi mushroom is under attack by another fungus and is no longer healthy. It is advised to throw away the Reishi substrate bag and notconsume the fruiting body as the green fungal species has potentially grown through the Reishi mushroom.",
  },
  {
    question: "When is the best time to harvest ?",
    answer:
      "Harvesting of the fruiting body can be done while the fruiting body is growing. It will grow back at the site where the mushroom was cut, so by doing this one can harvest the fruiting body multiple times. Typically after 4 months of mushroom fruiting body growth, the vitality and grow speed are reduced and the fruiting body can become overgrown by green or white fluffy fungi. It is therefore advised to harvest the mushroom fruiting body before this happens.",
  },
  {
    question:
      " There is green coloration on the substrate or on the mushroom itself, especially at the tips of the mushroom. What does this mean ?",
    answer:
      " This is very likely either Trichoderma (parasitic fungus) or a green Aspergillus species. Green coloration indicates that the Reishi mushroom is under attack by another fungus and is no longer healthy. It is advised to throw away the Reishi substrate bag and not consume the fruiting body as the green fungal species has potentially grown through the Reishi mushroom.",
  },
  {
    question:
      "   Why is the “go to shop” button linked to an external webshop ?",
    answer:
      " There is a collaboration between me and Pip Gilmore from Groenetakken.nl,in which I produce the Reishi Growkits and she sells them via her webshop.",
  },
]

export default data
